import styled from 'styled-components';

import { Breakpoint, Color } from '../../enums';
import { StyledComponent } from '../../interfaces';
import { Logo } from '../logo/logo.component';
import { MenuPosition } from '../menuPosition/menuPosition.component';

import { SocialsLinks } from './components/socialsLinks/socialsLinks.component';
import { TopBorderContainerProps } from './footer.types';

export const Container: StyledComponent<'div'> = styled.div`
  padding: 40px;
  background-color: ${Color.Gray200};
  position: relative;

  @media ${Breakpoint.Tablet} {
    padding: 32px;
  }

  @media ${Breakpoint.Mobile} {
    padding: 20px;
  }
`;

export const TopBorderContainer: StyledComponent<'div', TopBorderContainerProps> = styled.div<TopBorderContainerProps>`
  width: calc(100% - 80px);
  position: absolute;
  top: 0;
  ${({ $withTopBorder }: TopBorderContainerProps): string | false => $withTopBorder && `border-top: 1px solid ${Color.Gray300}`};

  @media ${Breakpoint.Tablet} {
    width: calc(100% - 64px);
  }

  @media ${Breakpoint.Mobile} {
    width: calc(100% - 40px);
  }
`;

export const StyledLogo: StyledComponent<typeof Logo> = styled(Logo)`
  width: 637px;
  margin-right: 40px;
  margin-bottom: 200px;

  @media ${Breakpoint.Tablet} {
    margin-bottom: 170px;
  }

  @media ${Breakpoint.Mobile} {
    margin-bottom: 120px;
  }

  @media ${Breakpoint.SmallMobile} {
    width: 100%;
  }
`;

export const LogoWithSocials: StyledComponent<'div'> = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;

  @media ${Breakpoint.Tablet} {
    flex-direction: column;
  }
`;

export const MenuPositionsColumn: StyledComponent<'div'> = styled.div`
  & + & {
    margin-left: 200px;

    @media ${Breakpoint.Tablet} {
      margin-left: 160px;
    }

    @media ${Breakpoint.Mobile} {
      margin-left: 80px;
    }

    @media ${Breakpoint.SmallMobile} {
      margin-left: 40px;
    }
  }
`;

export const MenuPositions: StyledComponent<'div'> = styled.div`
  display: flex;
  padding-top: 40px;
  border-top: 1px solid ${Color.Gray300};

  @media ${Breakpoint.Tablet} {
    padding-top: 32px;
  }
`;

export const StyledMenuPosition: StyledComponent<typeof MenuPosition> = styled(MenuPosition)`
  letter-spacing: 0.1em;
  text-transform: uppercase;

  & + & {
    margin-top: 12px;
  }
`;

export const StyledSocialsLinks: StyledComponent<typeof SocialsLinks> = styled(SocialsLinks)`
  @media ${Breakpoint.Tablet} {
    margin-bottom: 32px;
  }
`;
